import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const PhotoSharesSheetSkeleton: React.FC = () => (
  <div className="space-y-3">
    <Skeleton className="h-12 w-full" />
    <Skeleton className="h-12 w-full" />
    <Skeleton className="h-12 w-full" />
  </div>
)

export default PhotoSharesSheetSkeleton
